<template>
	<div class="page-content__content">
		<BlackListTable :productGroups="productGroups"/>
	</div>
</template>

<script>
import BlackListTable from "@/components/sections/BlackList/BlackListTable.vue";

export default {
	name: "BlackListPage",
	components: {BlackListTable},
	props: {
		productGroups: {
			type: Array,
			default: () => []
		},
	},
}
</script>


